module.exports = __webpack_public_path__ + "static/media/16.8389fbe0.JPG";